function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-6.5 -421.812)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.4,422.353a9.832,9.832,0,1,1-12.508,6.1,9.821,9.821,0,0,1,12.508-6.1Z",
  transform: "translate(-10.533)",
  className: "accent",
  fill: "#f7e842",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.5 425.34)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.668,462.667h-2.3L13,461.038a.448.448,0,0,0-.634-.634l-1.629,1.629v-2.3a.434.434,0,0,0-.869,0v2.281L8.256,460.4a.448.448,0,1,0-.634.634l1.629,1.629H6.934a.434.434,0,1,0,0,.869h2.3l-1.611,1.611a.437.437,0,0,0,0,.634.424.424,0,0,0,.308.127.4.4,0,0,0,.308-.127l1.611-1.611v2.317a.434.434,0,1,0,.869,0v-2.317l1.629,1.629a.424.424,0,0,0,.308.127.4.4,0,0,0,.308-.127.437.437,0,0,0,0-.634l-1.611-1.611h2.281a.429.429,0,0,0,.434-.434A.379.379,0,0,0,13.668,462.667Z",
  transform: "translate(-6.5 -456.042)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.1,445.1a.429.429,0,0,0-.434-.434H78.387l1.629-1.611a.448.448,0,0,0-.634-.634l-1.629,1.629v-2.317a.434.434,0,1,0-.869,0v2.3l-1.611-1.611a.448.448,0,0,0-.634.634l1.629,1.611H73.934a.434.434,0,1,0,0,.869h2.3L74.6,447.147a.437.437,0,0,0,0,.634.437.437,0,0,0,.615,0l1.611-1.611v2.3a.434.434,0,1,0,.869,0v-2.317l1.629,1.629a.424.424,0,0,0,.308.127.4.4,0,0,0,.308-.127.437.437,0,0,0,0-.634l-1.629-1.611H80.6A.461.461,0,0,0,81.1,445.1Z",
  transform: "translate(-61.372 -441.3)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.768,515.949H54.451l1.629-1.629a.448.448,0,0,0-.634-.634l-1.611,1.629v-2.281a.429.429,0,0,0-.434-.434.44.44,0,0,0-.434.434v2.281l-1.611-1.629a.448.448,0,1,0-.634.634l1.629,1.629H50.034a.434.434,0,1,0,0,.869h2.3l-1.611,1.611a.437.437,0,0,0,0,.634.424.424,0,0,0,.308.127.4.4,0,0,0,.308-.127l1.611-1.629v2.3a.429.429,0,0,0,.434.434.44.44,0,0,0,.434-.434v-2.281l1.611,1.629a.437.437,0,0,0,.615,0,.437.437,0,0,0,0-.634l-1.611-1.611h2.3a.429.429,0,0,0,.434-.434A.4.4,0,0,0,56.768,515.949Z",
  transform: "translate(-41.798 -499.694)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.668,492.231h-2.3l1.611-1.611a.448.448,0,0,0-.634-.634l-1.611,1.629v-2.281a.434.434,0,0,0-.869,0v2.281l-1.611-1.629a.448.448,0,1,0-.634.634l1.611,1.611h-2.3a.434.434,0,0,0,0,.869h2.317l-1.629,1.629a.437.437,0,0,0,0,.634.424.424,0,0,0,.308.127.4.4,0,0,0,.308-.127l1.611-1.629v2.281a.434.434,0,0,0,.869,0v-2.281l1.611,1.629a.437.437,0,0,0,.615,0,.437.437,0,0,0,0-.634l-1.629-1.629h2.317a.429.429,0,0,0,.434-.434A.372.372,0,0,0,120.668,492.231Z",
  transform: "translate(-94.132 -480.284)",
  className: "primary",
  fill: "#4e4e4e"
})));

var SvgSnow = function SvgSnow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.944,
    height: 24,
    viewBox: "0 0 26.944 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSnow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/snow.ccd80385.svg";
export { ForwardRef as ReactComponent };